import { useMemo } from 'react'
import { MembershipData } from 'src/types/membership'
import moment from 'moment'

/**
 * Hook to determine UnityPass trial state and related information
 * @param membershipData The membership data
 * @returns Trial state information
 */
export const useUnityPassTrialState = (membershipData?: MembershipData) => {
  return useMemo(() => {
    if (!membershipData) {
      return {
        isTrial: false,
        hasStopDate: false,
        daysUntilTrialEnd: 0,
        isActive: false
      }
    }

    const { activation } = membershipData

    // Check if the membership is a trial
    // Trial is determined by the discount type being 'trial'
    const isTrial = activation?.isTrial

    // Check if the membership has a stopDate
    const hasStopDate = Boolean(activation?.stopDate)

    // Calculate days until end date
    const endDate = activation?.endDate ? moment(activation.endDate) : null
    const daysUntilTrialEnd = endDate ? endDate.diff(moment(), 'days') : 0

    // Check if membership is active
    const isActive = Boolean(activation?.active)

    return {
      isTrial,
      hasStopDate,
      daysUntilTrialEnd,
      isActive
    }
  }, [membershipData])
}
